import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IContentMobile } from "../../../Pages/ContentMobile/IContentMobile";

export const DeleteContentMobileSlice = createSlice({
  name: "DeleteContentMobile",
  initialState: {} as IReduxState<IContentMobile>,
  reducers: {
    deleteContentMobile: (state, _) => {
      state.isLoading = true;
    },
    successdeleteContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteContentMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteContentMobile,
  failuredeleteContentMobile,
  successdeleteContentMobile,
  clearDeleteContentMobileResponse,
} = DeleteContentMobileSlice.actions;

export default DeleteContentMobileSlice.reducer;
